// mixin wykorzystywany w widokach z v-tabs
// zawiera tylko jedną funkcję, mającą na celu
// rerender slidera (linii pod akutalnie wybranym tabem)
// po zmianie języka

// elementom v-tabs należy dodać ref rozpoczynający się od tabs_
export default {
  mounted() {
    this.$root.$on("changedLanguage", () => {
      Object.keys(this.$refs)
        .filter(ref => ref.startsWith("tabs_"))
        .forEach(tab => {
          if (!this.$refs[tab].callSlider) {
            return;
          }
          this.$refs[tab].callSlider();
        });
    });
  },
  destroyed() {
    this.$root.$off("changedLanguage");
  }
};
